import React from 'react';
import PropTypes from 'prop-types';

import styles from './FlagList.module.scss';

const FlagList = ({items}) => (
  <ul className={styles.list}>
    {items.map((item, i) => (
      <li key={i}><span>{item}</span></li>
    ))}
  </ul>
);

FlagList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
};

export default FlagList;
